import Vue from 'vue';
export default Vue.extend({
    components: {
        'Lightbox': function () { return import(/* webpackChunkName: "Lightbox" */ '@app/components/Lightbox.vue'); },
        'Masonry': function () { return import(/* webpackChunkName: "Layout-Masonry" */ '@app/components/Layout/Masonry.vue'); },
        'Swiper': function () { return import(/* webpackChunkName: "Layout-Swiper" */ '@app/components/Layout/Swiper.vue'); },
    },
    props: {
        block: Object
    },
    data: function () { return ({
        currentImageIndex: null
    }); },
    methods: {
        openInLightbox: function (index) {
            this.currentImageIndex = index;
        }
    }
});
